/**
 * When one coach is registered under TWO same-duration templates (e.g. a
 * general "Private" @400/460 plus a coach-specific "Private (Off Peak)"
 * @330/460), the slot merge in use-booking-effects must decide which
 * template's pricing the coach card shows. Historically this was first-wins
 * over unordered RPC row output — nondeterministic, and it silently discarded
 * the tenant's off-peak discount (the Padel District Asaad & Hadi bug).
 *
 * A collision is treated as a DISCOUNT VARIANT — same product, cheaper
 * off-peak — only when the two templates' peak prices are identical and the
 * off-peak (normal) prices differ. That signature separates "one service with
 * an off-peak discount" from tenants whose same-duration templates are
 * genuinely different services sharing a coach (OIA's salon menu, Karama's
 * on-site/off-site sessions, TRS's tennis vs kids academy — all differ at
 * peak too). For those, replacing the resource would display one service's
 * price for another, so the guard must NOT be widened to plain cheapest-wins.
 */
type CollidingResourcePricing = {
  normal_price: number;
  peak_price: number;
};

export function isDiscountVariantOf(
  candidate: CollidingResourcePricing,
  existing: CollidingResourcePricing,
): boolean {
  return (
    candidate.peak_price === existing.peak_price &&
    candidate.normal_price < existing.normal_price
  );
}
